module.exports = __webpack_public_path__ + "static/media/shop-history-icon.f4d16f54.svg";